import * as React from 'react';
import Chip from '@material-ui/core/Chip';
import styled from 'styled-components';

interface SelectMenuItemChipProps {
  title: string;
  bgColor?: string;
  color?: string;
}

export const SelectMenuItemChip: React.FC<React.PropsWithChildren<SelectMenuItemChipProps>> = ({
  bgColor,
  color,
  title
}) => (
  <StyledChip
    size="small"
    label={title}
    style={{
      backgroundColor: bgColor ?? '#DCE0E5',
      color: color ?? '#444D55'
    }}
  />
);

const StyledChip = styled(Chip)`
  && {
    height: 17px;
    span {
      font-size: 10px;
      font-weight: 500;
    }
  }
`;
